import { useApolloClient } from "@apollo/client";
import { BoundSelectField, Button, FormLines, ModalBody, ModalFooter, ModalHeader, useSnackbar } from "@homebound/beam";
import { ObjectConfig, required, useFormState } from "@homebound/form-state";
import { LienWaiverType, SaveLienWaiverInput } from "src/generated/graphqlTypes";
import { LienWaiversPageDocument, useSaveLienWaiverMutation } from "src/routes/lien-waivers/LienWaiversPage.generated";
type CreateLienWaiverModalProps = {
  tradePartners: { id: string; name: string }[];
  projects: { id: string; name: string }[];
  closeModal: () => void;
};

export function CreateLienWaiverModal({ tradePartners, projects, closeModal }: CreateLienWaiverModalProps) {
  const { triggerNotice } = useSnackbar();
  const [saveFinalLienWaiver] = useSaveLienWaiverMutation();
  const client = useApolloClient();

  const formState = useFormState({ config: formConfig });

  return (
    <>
      <ModalHeader>Create Final Lien Waiver</ModalHeader>
      <ModalBody>
        <form>
          <FormLines width="full">
            <BoundSelectField field={formState.claimantId} label="Trade Partner" options={tradePartners} />
            <BoundSelectField field={formState.parentId} label="Project" options={projects} />
          </FormLines>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button variant="quaternary" label="Cancel" onClick={closeModal} />
        <Button
          label="Save"
          onClick={async () => {
            try {
              const { data } = await saveFinalLienWaiver({
                variables: { input: { ...formState.value, type: LienWaiverType.Final } },
              });
              if (data?.saveLienWaiver.lienWaiver) {
                await client.refetchQueries({ include: [LienWaiversPageDocument] });
                triggerNotice({
                  icon: "success",
                  message: `Final Lien Waiver ${data.saveLienWaiver.lienWaiver.id} successfully created`,
                });
              }
            } catch (e) {
              console.error(e);
            } finally {
              closeModal();
            }
          }}
        />
      </ModalFooter>
    </>
  );
}

const formConfig: ObjectConfig<SaveLienWaiverInput> = {
  claimantId: { type: "value", rules: [required] },
  parentId: { type: "value", rules: [required] },
};
